<template>
  <div :data-test-id="dataTestId" :class="outerClass" :style="inlineStyle">
    <p v-if="props.fields?.heading?.value" class="text-base-bold uppercase">{{ props.fields.heading.value }}</p>
    <div
      v-if="props.fields?.slides && props.fields.slides.length > 0"
      class="relative no-scrollbar"
      aria-label="Featured Items Carousel"
      tabindex="-1"
      aria-roledescription="carousel"
    >
      <div
        ref="scroller"
        class="-mx-4 md:-mx-8 xl:-mx-25 xl:mr-[min(-100px,calc(-1*(100vw-1363px)))] py-3 pl-4 md:px-8 xl:px-25 flex overflow-x-auto scroll-smooth snap-x snap-mandatory gap-6"
        role="group"
        aria-label="Items Scroller"
        aria-live="polite"
        @scroll="updateButtons"
      >
        <div
          v-for="(slideData, slideIndex) in props.fields?.slides"
          :key="`slide_${slideIndex}`"
          class="snap-start scroll-ml-4 md:scroll-ml-8 xl:scroll-ml-25"
          :data-test-id="props.fields.slides[slideIndex].fields?.dataTestId?.value || dataTestId + '_' + slideIndex"
        >
          <BrandBadge v-if="props.fields.slides[slideIndex].fields.Image" v-bind="props.fields.slides[slideIndex]" />
          <Tile v-if="props.fields.slides[slideIndex].fields.icon" v-bind="props.fields.slides[slideIndex]" />
          <PromoCardImageSlide
            v-if="props.fields.slides[slideIndex].fields.tag"
            v-bind="{
              fields: {
                items: [{ fields: props.fields.slides[slideIndex].fields }],
                height: props.fields.height?.value,
              },
            }"
          />
        </div>
      </div>

      <button
        ref="previous"
        type="button"
        title="Previous Item"
        class="hidden md:block bg-racq-dark-grey p-[10px] rounded-full absolute -left-2 md:-left-4 top-1/2 -translate-y-1/2"
        aria-controls="gui-carousel--controls"
        aria-label="Previous Item"
        @click="scrollCarousel('left')"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path
            d="M14.666 7.99924C14.6733 8.21671 14.5954 8.42827 14.4493 8.58778C14.3031 8.7473 14.1007 8.84182 13.886 8.85073L4.01096 8.85073L8.03153 13.2135C8.17934 13.3782 8.26124 13.5927 8.26124 13.8153C8.26124 14.0378 8.17934 14.2524 8.03153 14.417C7.96149 14.4955 7.87597 14.5583 7.78051 14.6012C7.68504 14.6442 7.58174 14.6663 7.47728 14.6663C7.37283 14.6663 7.26953 14.6442 7.17406 14.6012C7.07859 14.5583 6.99308 14.4955 6.92304 14.417L1.5643 8.60231C1.5272 8.5621 1.49411 8.51829 1.46549 8.47151C1.45336 8.4522 1.44469 8.43025 1.43429 8.40918C1.41889 8.38083 1.40529 8.35151 1.39356 8.3214C1.38384 8.29263 1.37573 8.26332 1.36929 8.23362C1.36236 8.20904 1.35369 8.18534 1.34849 8.15988C1.32806 8.04965 1.32806 7.93653 1.34849 7.8263C1.35282 7.80085 1.36149 7.77715 1.36929 7.75257C1.37571 7.72286 1.38381 7.69355 1.39356 7.66478C1.40529 7.63468 1.41889 7.60536 1.43429 7.577C1.44469 7.55593 1.45249 7.53487 1.46549 7.51468C1.49418 7.46795 1.52727 7.42414 1.5643 7.38388L6.92304 1.58231C6.99308 1.50382 7.07859 1.44108 7.17406 1.39814C7.26953 1.3552 7.37282 1.33301 7.47728 1.33301C7.58174 1.33301 7.68504 1.3552 7.78051 1.39814C7.87597 1.44108 7.96149 1.50382 8.03153 1.58231C8.17934 1.74697 8.26124 1.96152 8.26124 2.18406C8.26124 2.40661 8.17934 2.62116 8.03153 2.78581L4.01096 7.14862L13.886 7.14862C14.1007 7.15753 14.3031 7.25205 14.4493 7.41157C14.5954 7.57108 14.6733 7.78176 14.666 7.99924Z"
            fill="white"
          />
        </svg>
      </button>
      <button
        ref="next"
        type="button"
        title="Next Item"
        class="hidden md:block bg-racq-dark-grey p-[10px] rounded-full absolute -right-2 md:-right-4 xl:mr-[min(0px,calc(-1*(100vw-1448px)))] top-1/2 -translate-y-1/2"
        aria-controls="gui-carousel--controls"
        aria-label="Next Item"
        @click="scrollCarousel('right')"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path
            d="M1.33372 8.00076C1.32645 7.78329 1.40437 7.57173 1.55049 7.41222C1.69661 7.2527 1.89908 7.15818 2.11374 7.14927H11.9888L7.96823 2.78646C7.82042 2.62181 7.73852 2.40726 7.73852 2.18471C7.73852 1.96217 7.82042 1.74762 7.96823 1.58296C8.03827 1.50447 8.12378 1.44173 8.21925 1.39879C8.31472 1.35585 8.41802 1.33366 8.52247 1.33366C8.62693 1.33366 8.73023 1.35585 8.8257 1.39879C8.92116 1.44173 9.00668 1.50447 9.07672 1.58296L14.4355 7.3977C14.4726 7.4379 14.5056 7.48171 14.5343 7.52849C14.5464 7.5478 14.5551 7.56975 14.5655 7.59082C14.5809 7.61918 14.5945 7.6485 14.6062 7.6786C14.6159 7.70737 14.624 7.73668 14.6305 7.76638C14.6374 7.79096 14.6461 7.81466 14.6513 7.84012C14.6717 7.95035 14.6717 8.06347 14.6513 8.1737C14.6469 8.19915 14.6383 8.22285 14.6305 8.24743C14.6241 8.27714 14.6159 8.30645 14.6062 8.33522C14.5945 8.36532 14.5809 8.39464 14.5655 8.423C14.5551 8.44407 14.5473 8.46514 14.5343 8.48533C14.5056 8.53206 14.4725 8.57586 14.4355 8.61612L9.07672 14.4177C9.00668 14.4962 8.92116 14.5589 8.8257 14.6019C8.73023 14.6448 8.62693 14.667 8.52247 14.667C8.41802 14.667 8.31472 14.6448 8.21925 14.6019C8.12378 14.5589 8.03827 14.4962 7.96823 14.4177C7.82042 14.253 7.73852 14.0385 7.73852 13.8159C7.73852 13.5934 7.82042 13.3788 7.96823 13.2142L11.9888 8.85138H2.11374C1.89908 8.84247 1.69661 8.74795 1.55049 8.58843C1.40437 8.42892 1.32645 8.21824 1.33372 8.00076Z"
            fill="white"
          />
        </svg>
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, ref } from 'vue';
import { ComponentFields, ComponentRendering } from '@sitecore-jss/sitecore-jss/types/layout';
import BrandBadge from '../BrandBadge/BrandBadge.vue';
import Tile from '../Tile/Tile.vue';
import { usePageStore } from '@/store';
import PromoCardImageSlide from '../PromoCardImage/PromoCardImageSlide.vue';

// ----------------------------------------------------------------------------------
// Define variables
// ----------------------------------------------------------------------------------
const props = defineProps<{
  fields?: ComponentFields;
  rendering?: ComponentRendering;
}>();

const outerClass = props.rendering?.params?.Styles;
const inlineStyle = props.rendering?.params?.inlineStyle;
const dataTestId = usePageStore().dataTestId(props.rendering);
const scroller = ref<HTMLDivElement>();
const previous = ref<HTMLButtonElement>();
const next = ref<HTMLButtonElement>();

// ----------------------------------------------------------------------------------
// Life hooks
// ----------------------------------------------------------------------------------
onMounted(() => {
  window.addEventListener('resize', updateButtons);
  updateButtons();
});

onUnmounted(() => {
  window.removeEventListener('resize', updateButtons);
});

// ----------------------------------------------------------------------------------
// Functions
// ----------------------------------------------------------------------------------
function updateButtons() {
  if (!scroller.value || window.innerWidth < 600) return;
  if (scroller.value.scrollLeft <= 10) {
    // 10px for a bit of buffer
    previous.value?.classList.add('invisible');
  } else {
    previous.value?.classList.remove('invisible');
  }
  if (scroller.value.scrollLeft >= scroller.value.scrollWidth - scroller.value.clientWidth - 1) {
    next.value?.classList.add('invisible');
  } else {
    next.value?.classList.remove('invisible');
  }
}

function scrollCarousel(direction: string) {
  const slideWidth = scroller.value!.children[0].getBoundingClientRect().width + 24;
  const scrollAmount = direction === 'left' ? -slideWidth : slideWidth;
  scroller.value?.scrollBy({ left: scrollAmount, behavior: 'smooth' });
}
</script>
